import { render } from "./PatientSchedule.vue?vue&type=template&id=2a424fd0"
import script from "./PatientSchedule.ts?vue&type=script&lang=js&external"
export * from "./PatientSchedule.ts?vue&type=script&lang=js&external"

import "./PatientSchedule.vue?vue&type=style&index=0&id=2a424fd0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__